/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setMouseStalker.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

//gsapのプラグインを登録
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let mouseLock;
let option = { duration: 0.7, ease: "power4.out", overwrite: true, }

/**
 * mouseStalker
 */
function mouseStalker() {
  mouseLock = false;
  let stalker, pos, mouse, speed, xSet, ySet;
  let hover__stkTransform__btnBlock = document.querySelectorAll('.--js__stk-btnBlock');
  let hover__stkTransform__btnBlockR = document.querySelectorAll('.--js__stk-btnBlockR');
  let hover__stkTransform__scale_up = document.querySelectorAll('.--js__stk-scale-up');
  let hover__stkTransform__scale_down = document.querySelectorAll('.--js__stk-scale-down');

  //初期設定
  const init = () => {
    stalker = document.querySelector('.stalker');
    pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    speed = 0.15;
    xSet = gsap.quickSetter(stalker, "x", "px");
    ySet = gsap.quickSetter(stalker, "y", "px");
  }

  //ポインターの初期設定
  const pointerProcess = (init = false) => {
    mouseLock = false;
    window.addEventListener("mousemove", (event) => {
      const rectSize = 10;
      mouse.x = event.x - rectSize / 2;
      mouse.y = event.y - rectSize / 2;
    });
    if (init) {
      gsap.to(stalker, {
        width: 12,
        height: 12,
        borderRadius: "24px",
        scale: 1,
        backgroundColor: "#EF604D",
        ...option,
      });
    }
  }

  //ストーカー実装
  const setStalker = () => {
    gsap.ticker.add(() => {
      if (mouseLock === true) {
        return;
      }
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });
  }

  //変形 - ボタン(blcok type)
  const stkTransform__btnBlock = (e) => {
    const rect = e.getBoundingClientRect();
    mouseLock = true;
    mouse.x = pos.x = rect.x;
    mouse.y = pos.y = rect.y;
    gsap.to(stalker, {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      scale: 1,
      borderRadius: 0,
      backgroundColor: "transparent",
      duration: 0.5,
      ease: "back.out",
      overwrite: true,
    });
  }

  //変形 - ボタン(blcok type Radius)
  const stkTransform__btnBlockR = (e) => {
    const rect = e.getBoundingClientRect();
    mouseLock = true;
    mouse.x = pos.x = rect.x;
    mouse.y = pos.y = rect.y;
    gsap.to(stalker, {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      scale: 1,
      borderRadius: rect.width / 2,
      backgroundColor: "transparent",
      duration: 0.5,
      ease: "back.out",
      overwrite: true,
    });
  }

  //変形 - アンダーライン
  const stkTransform__underline = (e) => {
    mouseLock = true;
    const rect = e.getBoundingClientRect();
    mouse.x = pos.x = rect.x - 1;
    mouse.y = pos.y = rect.y - 1;
    gsap.to(stalker, {
      x: rect.x - 1,
      y: rect.height + rect.y - 1,
      width: rect.width,
      height: "1px",
      scale: 1,
      borderRadius: 0,
      duration: 0.5,
      ease: "back.out",
      overwrite: true,
    });
  }

  //変形 - 拡大
  const stkTransform__scale = (e, props) => {
    const rect = e.getBoundingClientRect();
    let propsType = {
      up: { width: rect.width * 1.2, height: rect.width * 1.2, scale: 1, borderRadius: rect.width * 1.2, backgroundColor: "transparent", },
      down: { scale: 0, duration: 1, }
    }
    window.addEventListener("mousemove", (event) => {
      let center_x = event.x - rect.width / 2;
      let center_y = event.y - rect.width / 2;
      if (props === "up") {
        mouse.x = center_x;
        mouse.y = center_y;
      }
    });
    gsap.to(stalker, {
      ...propsType[props],
      ...option,
    });
  }

  //初期化
  window.addEventListener("load", () => {
    init();
    pointerProcess(true);
    setStalker();
  })

  //ホバー - ボタン(blcok type)
  hover__stkTransform__btnBlock.forEach((item) => {
    item.addEventListener("mouseenter", () => stkTransform__btnBlock(item))
    item.addEventListener("mouseleave", () => pointerProcess(true))
  })

  //ホバー - ボタン(blcok type Radius)
  hover__stkTransform__btnBlockR.forEach((item) => {
    item.addEventListener("mouseenter", () => stkTransform__btnBlockR(item))
    item.addEventListener("mouseleave", () => pointerProcess(true))
  })

  //ホバー - 拡大
  hover__stkTransform__scale_up.forEach((item) => {
    item.addEventListener("mouseenter", () => stkTransform__scale(item, "up"))
    item.addEventListener("mouseleave", () => pointerProcess(true))
  })

  //ホバー - 縮小
  hover__stkTransform__scale_down.forEach((item) => {
    item.addEventListener("mouseenter", () => stkTransform__scale(item, "down"))
    item.addEventListener("mouseleave", () => pointerProcess(true))
  })
}

/**
 * mouseStalker - CONTENTS - We have - point img
 */
function mouseStalker__contents__weHave__pointImg() {
  let stalker, pos, mouse, speed, xSet, ySet;
  let hoverDetection = document.querySelectorAll('.point__list-item');

  //初期設定
  const init = () => {
    stalker = document.querySelector('.--js_mouseStalker-pointImg');
    pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    speed = 0.15;
    xSet = gsap.quickSetter(stalker, "x", "px");
    ySet = gsap.quickSetter(stalker, "y", "px");
  }

  //ポインターの初期設定
  const pointerProcess = () => {
    window.addEventListener("mousemove", (event) => {
      mouse.x = event.x + stalker.clientWidth / 6;
      mouse.y = event.y - stalker.clientHeight / 2;
      gsap.utils.toArray(stalker.querySelectorAll('img')).forEach((item) => {
        gsap.to(item, {
          x: (event.x - item.clientWidth / 2) / (item.clientWidth / 2) * 6,
          y: (event.y - item.clientHeight / 2) / (item.clientHeight / 2) * 36,
          ...option,
        });
      });
    });
  }

  //ストーカー実装
  const setStalker = () => {
    gsap.ticker.add(() => {
      if (mouseLock === true) {
        return;
      }
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });
  }

  const pointItemRotateZ = () => {
    hoverDetection.forEach((item) => {
      const rect = item.getBoundingClientRect();
      item.addEventListener("mousemove", (event) => {
        let negative_x = event.x - rect.x - rect.width;
        let x = negative_x / (rect.width / 2) * 7;
        gsap.to(stalker, {
          rotateZ: x,
          ...option,
        });
      });
    });
  }

  //初期化
  window.addEventListener("load", () => {
    if (window.document.body.classList.contains("home")) {
      init();
      pointerProcess();
      setStalker();
      pointItemRotateZ();
    }
  })
}

export { mouseStalker, mouseStalker__contents__weHave__pointImg };